import { render } from "./notifiCations.vue?vue&type=template&id=6497fbd0"
import script from "./notifiCations.vue?vue&type=script&lang=js"
export * from "./notifiCations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__